/**
 * Deterministic pseudo-random number generator.
 *
 * Every randomised decision in BEX LOOP (scene selection, procedural
 * variation) goes through an injected RNG. That keeps the engine
 * testable: the same seed always produces the same result.
 */

/** Mulberry32 - small, fast, good enough for visual selection. */
export function createRng(seed = 1) {
  let a = seed >>> 0;
  const rng = () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
  rng.int = (maxExclusive) => Math.floor(rng() * maxExclusive);
  rng.pick = (arr) => arr[rng.int(arr.length)];
  rng.seed = seed;
  return rng;
}

/** Turn an arbitrary string into a stable 32-bit seed. */
export function seedFromString(str) {
  let h = 2166136261 >>> 0;
  for (let i = 0; i < str.length; i += 1) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619) >>> 0;
  }
  return h >>> 0;
}

/** Global RNG used when no seed is supplied (uses crypto when available). */
export const systemRng = createRng(
  typeof globalThis.crypto?.getRandomValues === 'function'
    ? globalThis.crypto.getRandomValues(new Uint32Array(1))[0]
    : Date.now() >>> 0,
);
